import React, { useState, useEffect, Fragment, useMemo } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import HomeService from '../../Api/services/HomeService';
import PaymentService from '../../Api/services/PaymentService';
import { differenceInCalendarMonths } from "date-fns";
import { NumericFormat } from 'react-number-format';
import { CLIENT_ID } from '../../Config/Config';
import { useTranslation } from "react-i18next";
import moment from "moment";
const initialOptions = {
  clientId: "test",
  currency: "EUR",
  intent: "capture",
  "client-id": CLIENT_ID
};
const Payment = (props) => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  if (localStorage.getItem("payment_status") === null) {
    navigate("/")
  }
  const [sessionex, setsessionex] = useState(true);

  const checkForInactivity = () => {
    // const expireTime = 1000000
    const expireTime = localStorage.getItem("expireTime");
    if (expireTime < Date.now()) {
      console.log("logout")
      setsessionex(false);
    }
  }
  //function to update expire time
  const updateExpireTime = () => {
    const expiretime = Date.now() + 5000;

    localStorage.setItem("expireTime", expiretime);
  }


  //Update Expire time on any user acitivy
  useEffect(() => {
    if (localStorage.getItem("payment_status") === null) {
      navigate("/")
    }
    const interval = setInterval(() => {
      checkForInactivity();
    }, 300000);
    // }, 1000);

    //clean interval on unmount
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    updateExpireTime();
    window.addEventListener("click", updateExpireTime);
    window.addEventListener("keypress", updateExpireTime);
    window.addEventListener("scroll", updateExpireTime);
    window.addEventListener("mousemove", updateExpireTime);

    //clean up
    return () => {
      window.removeEventListener("click", updateExpireTime);
      window.removeEventListener("keypress", updateExpireTime);
      window.removeEventListener("scroll", updateExpireTime);
      window.removeEventListener("mousemove", updateExpireTime);
    }
  }, []);
  //Use Effect to set Interval to check for inactivity


  const getDetails = useLocation();
  const [differenceMonth, setDifferenceMonth] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  var propsPersonal;
  var propsDetail;

  if (searchParams.get("canceled")) {

    propsPersonal = JSON.parse(localStorage.getItem('propsPersonal'))
    propsDetail = JSON.parse(localStorage.getItem('detailData'));

  } else {
    propsPersonal = getDetails.state.userData;
    propsDetail = getDetails.state.detailData;
    localStorage.setItem("propsPersonal", JSON.stringify(propsPersonal));
    localStorage.setItem("detailData", JSON.stringify(propsDetail));
  }



  const [skills, setSkills] = useState([]);
  const [location, setLocation] = useState([]);
  const [show, setShow] = useState(false);
  const [success, setSuccess] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");
  const [orderID, setOrderID] = useState(false);
  const [isSubmitPayment, setIsSubmitPayment] = useState(false);
  const [amount, setAmount] = useState('');
  const [vouchercode, setCode] = useState('');

  const [payerdetail, setPayerDetails] = useState('');
  const [currentInformation, setCurrentInformation] = useState();
  const [termcheck, settermcheck] = useState(false);
  const [is_Cod, setIs_code] = useState(true);
  const [is_paypal, setIs_paypal] = useState(false);
  const [error, setError] = useState();
  const [discountAmount, setDiscountAmount] = useState(0);
  const [voucherMessage, setVoucherMessage] = useState('');
  const [isvalidvoucher, setIsvalidVoucher] = useState(false);

  var imageUrl = process.env.REACT_APP_LARAVEL_CAMPER_IMAGE_URL;
  let dateRange = propsDetail.date;

  let dateSelected = dateRange.split("_");
  let startDate = dateSelected[0];
  let endDate = dateSelected[1];
  let childtotal = propsDetail.camperPrice * propsDetail.days;
  let total = parseFloat(propsDetail.totalPackages) + parseInt(propsDetail.serviceFee) + parseInt(childtotal);
  let totalnumberamount = propsDetail.totalCamperPrice


  useEffect(() => {
    window.scrollTo(0, 0);
    getLocation();

    if (dateRange) {
      let startDate1 = dateRange.split("_");
      let result = 0;
      result = differenceInCalendarMonths(
        new Date(startDate1[1]),
        new Date(startDate1[0])
      );

      setDifferenceMonth(result)
    }


    if (success) {

      checkOrder(orderID)
    }
  }, [success]);
  const getLocation = async () => {
    try {
      let locationList = await HomeService.location().json();
      setLocation(locationList.data);
      let getdata = locationList.data.filter(function (item) {
        return item.id == propsDetail.location;
      });
      setSkills(getdata);
    } catch (error) {
      console.log(error);
    }
  };
  const handleAmount = () => {
    setIs_paypal(is_paypal ? false : true)

    if (is_paypal === false) {

      setShow(true)
      setIs_code(is_Cod ? false : true)

      let childtotal = propsDetail.camperPrice * propsDetail.days;
      let total = parseInt(propsDetail.totalPackages) + parseInt(propsDetail.serviceFee) + parseInt(childtotal);
      setAmount(total)
    }
    else {
      setShow(false)
      setIs_code(is_Cod ? false : true)
    }

  }

  const createOrder = (data, actions) => {
    return actions.order.create({
      purchase_units: [
        {
          description: "Buy Camper",
          amount: {
            value: amount ? amount : 0,
          },
        },
      ],
    }).then((orderID) => {
      setOrderID(orderID);
      return orderID;
    });
  };
  // check Approval
  const onApprove = (data, actions) => {
    return actions.order.capture().then(function (details) {
      const { payer } = details;
      setPayerDetails(details)
      // console.log(details);
      setSuccess(true);
    });
  };
  const onError = (data, actions) => {
    setErrorMessage("An Error occured with your payment ");
  };

  var userId;
  if (searchParams.get("canceled")) {
    userId = JSON.parse(localStorage.getItem('userId'))

  } else {
    var userId = getDetails.state.user_id
    localStorage.setItem("userId", JSON.stringify(userId));
  }
  const checkOrder = async (orderID) => {

    var accessoryData = propsDetail.AccessoriesPackages.map((element) => { return element.id });
    var serviceData = propsDetail.servicePackages.map((element) => { return element.id });
    var serviceDataFix = propsDetail.servicePackagesFix.map((element) => { return element.id });
    var packageData = propsDetail.packages.map((element) => { return element.id });
    var cancellation = propsDetail.cancelpackages.map((element) => { return element.id });
    var KilometerPackages = propsDetail.kilometerpackage && propsDetail.kilometerpackage.map((element) => { return element.id });
    var AccessoriesPackagesFix = propsDetail.AccessoriesPackagesFix.map((element) => { return element.id });
    serviceData.push(...serviceDataFix)
    accessoryData.push(...AccessoriesPackagesFix)
    try {

      var data = {
        orderid: orderID,
        user_id: userId,
        camper_id: propsDetail.id,
        start_date: startDate + ' ' + propsDetail.pickup + ":00",
        end_date: endDate + ' ' + propsDetail.return + ":00",
        // total_amount: total,
        total_amount: propsDetail.type == "Subscription" ? Math.round(propsDetail.monthlyBreakdown?.[0]?.price ?? 0) : (Math.round(propsDetail.totalPackages - parseInt(discountAmount))),
        full_name: propsPersonal.name,
        email: propsPersonal.email,
        phone: propsPersonal.phone,
        address: propsPersonal.street + "," + propsPersonal.address + "," + propsPersonal.zip,
        address_2: propsPersonal.city + "," + propsPersonal.country,
        dob: propsPersonal.dob,
        payment_status: "",
        payment_date: "",
        is_refunds: "",
        is_cod: 0,
        is_paid: 1,
        "lng": i18n.resolvedLanguage,
        company: propsPersonal.company,
        vat_id: propsPersonal.vat_id,
        "package_ids": packageData ? packageData : '',
        "cancaletion_ids": cancellation ? cancellation : '',
        "services_ids": serviceData ? serviceData : '',
        "Kilometer_ids": KilometerPackages ? KilometerPackages : '',
        // "serviceDataFix": serviceDataFix,
        "accessories_ids": accessoryData ? accessoryData : '',
        // "accesspriesDataFix": AccessoriesPackagesFix,

      }
      // console.log(data);
      await PaymentService.store(data).json()
      // getCredits();

      setAmount(0)
      // navigate('/thankyou')
      navigate('/thankyou', { replace: true })
    }
    catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();

        setErrorMessage(errorJson.message)
      }
    }
  }

    const onSubmitForm = async (event) => {
    event.preventDefault();
    setIsSubmitPayment(true);
    const randomId =
      "id-" +
      Math.random().toString(36).substr(2, 9) +
      "-" +
      Date.now().toString(36);
    var accessoryData = propsDetail.AccessoriesPackages.map((element) => { return element.id });
    var serviceData = propsDetail.servicePackages.map((element) => { return element.id });
    var serviceDataFix = propsDetail.servicePackagesFix.map((element) => { return element.id });
    var AccessoriesPackagesFix = propsDetail.AccessoriesPackagesFix.map((element) => { return element.id });
    var KilometerPackages = propsDetail.kilometerpackage && propsDetail.kilometerpackage.map((element) => { return element.id });
    var packageData = propsDetail.packages.map((element) => { return element.id });
    var cancellation = propsDetail.cancelpackages.map((element) => { return element.id });

    serviceData.push(...serviceDataFix)
    accessoryData.push(...AccessoriesPackagesFix)

    const numMonths = monthlyBreakdown?.length || 1;
    const voucherPerMonth = discountAmount > 0 ? parseInt(discountAmount) / numMonths : 0;

    const formattedMonthlyBreakdown = monthlyBreakdown?.map(item => ({
      month: item.index,
      range: item.range,
      price: item.price,
      // discount_applied: Math.round(voucherPerMonth),
      // original_price: Math.round(item.price + voucherPerMonth)
    }));

    try {
      const orderType = propsDetail.type == "Subscription" ? "subscription" : "rental";
      localStorage.setItem("camper_order_type", orderType);

      var userdata = {
        orderid: randomId,
        user_id: userId,
        camper_id: propsDetail.id,
        start_date: startDate + ' ' + propsDetail.pickup + ":00",
        end_date: endDate + ' ' + propsDetail.return + ":00",
        ...(propsDetail.type != "Subscription" && {
          pickup_charge: propsDetail.pickup_charge,
          return_charge: propsDetail.return_charge,
        }),
        ...(propsDetail.type == "Subscription" && {
          subscription_discount: propsDetail.discountPercentage,
        }),
        // total_amount: propsDetail.type == "Subscription" ? Math.round(propsDetail.monthlyBreakdown?.[0]?.price ?? 0) : (Math.sign(((parseInt(propsDetail.totalPackages)) - (parseInt(discountAmount)))) === -1 ? 0 : ((parseInt(propsDetail.totalPackages)) - (parseInt(discountAmount)))),
        total_amount: propsDetail.type == "Subscription"
          // ? Math.round(propsDetail.monthlyBreakdown?.[0]?.price ?? 0)
          ?monthlyBreakdown?.[0]?.price
          : (
            (Math.sign((parseInt(propsDetail.totalPackages)) - (parseInt(discountAmount))) === -1
              ? 0
              : ((parseInt(propsDetail.totalPackages)) - (parseInt(discountAmount)))
            )
            + parseInt(propsDetail.pickup_charge || 0)
            + parseInt(propsDetail.return_charge || 0)
          ),
        // total_amount: Math.round(propsDetail.totalPackages - parseInt(discountAmount)),
        month_array: formattedMonthlyBreakdown,
        full_name: propsPersonal.name,
        email: propsPersonal.email,
        phone: propsPersonal.phone,
        address: propsPersonal.street + "," + propsPersonal.address + "," + propsPersonal.zip,
        address_2: propsPersonal.city + "," + propsPersonal.country,
        dob: propsPersonal.dob,
        payment_status: "",
        payment_date: "",
        is_refunds: "",
        is_cod: is_Cod ? 1 : 0,
        is_paid: is_Cod ? 0 : 1,
        company: propsPersonal.company,
        vat_id: propsPersonal.vat_id,
        "vouchercode": isvalidvoucher ? vouchercode : '',
        "package_ids": packageData ? packageData : '',
        "cancaletion_ids": cancellation ? cancellation : '',
        "services_ids": serviceData ? serviceData : '',
        "Kilometer_ids": KilometerPackages ? KilometerPackages : '',
        // "serviceDataFix": serviceDataFix,
        "accessories_ids": accessoryData ? accessoryData : '',
        "lng": i18n.resolvedLanguage,

        // "accesspriesDataFix": AccessoriesPackagesFix,
      }
      setAmount(0)

      if (is_Cod) {

        var responsedata = await PaymentService.store(userdata).json();
        if(responsedata.status == false || responsedata.success == false){
          if (i18n.resolvedLanguage == 'en') {
            setError(responsedata.message);
            setIsSubmitPayment(false);
            return;
          } else {
            setError(responsedata.german_message);
            setIsSubmitPayment(false);
            return;
          }
        }

        if (responsedata.order_id) {
          var payload = {
            "order_status": 1
          }
          
          await PaymentService.registerconfirm(userId, payload).json();

          localStorage.setItem(
            `thankyou_track_${responsedata.order_id}`,
            JSON.stringify({
              order_id: responsedata.order_id,
              payment_type: responsedata.payment_method || "cash",
              total_price: responsedata.value || 0,

              email: userdata?.email || "",
              camper_model: propsDetail?.title || "",
              start_date: userdata?.start_date || "",
              end_date: userdata?.end_date || "",
            })
          );

          setIsSubmitPayment(false);

          navigate("/thankyou", {
            replace: true,
            state: {
              order_id: responsedata.order_id,
              payment_type: responsedata.payment_method || "cash",
              total_price: userdata.total_amount, // Uses the exact amount you sent to the API
              camper_model: propsDetail.title,    // Grabs the camper name
              start_date: startDate,              // Grabs the formatted start date
              end_date: endDate,                  // Grabs the formatted end date
              email: propsPersonal.email
            },
          });
        }
      } else {

        var accessoryData = propsDetail.AccessoriesPackages.map((element) => { return element.title + "_" + element.price });
        var serviceData = propsDetail.servicePackages.map((element) => { return element.title + "_" + element.price });
        var serviceDataFix = propsDetail.servicePackagesFix.map((element) => { return element.title + "_" + element.price });
        var packageData = propsDetail.packages.map((element) => { return element.title + "_" + element.price });
        var cancellation = propsDetail.cancelpackages.map((element) => { return element.title + "_" + element.price });
        var AccessoriesPackagesFix = propsDetail.AccessoriesPackagesFix.map((element) => { return element.title + "_" + element.price });
        var KilometerPackages = propsDetail.kilometerpackage && propsDetail.kilometerpackage.map((element) => { return element.title + "_" + element.price });
        serviceData.push(...serviceDataFix)
        accessoryData.push(...AccessoriesPackagesFix)
        // For subscription: camper_price = first month price with voucher applied
        // All other additive fields zeroed so backend formula gives exactly first month price
        const isSubscription = propsDetail.type == "Subscription";
        const firstMonthPrice = isSubscription
          ? (monthlyBreakdown?.[0]?.price ?? Math.round(propsDetail.totalCamperPrice))
          : Math.round(propsDetail.totalCamperPrice);

        var stripedata = {
          "camper": propsDetail.title,
          "camper_price": firstMonthPrice,
          "stripe_amount": firstMonthPrice,
          "first_month_price": firstMonthPrice,
          "camper_days": isSubscription ? 1 : propsDetail.days,
          "service_fees": isSubscription ? 0 : propsDetail.serviceFee,
          "package_ids": isSubscription ? [] : (packageData ? packageData : ''),
          "cancaletion_ids": isSubscription ? [] : (cancellation ? cancellation : ''),
          "services_ids": isSubscription ? [] : (serviceData ? serviceData : ''),
          "Kilometer_ids": isSubscription ? [] : (KilometerPackages ? KilometerPackages : ''),
          "accessories_ids": isSubscription ? [] : (accessoryData ? accessoryData : ''),
          'discount': isSubscription ? 0 : (parseInt(discountAmount) ? parseInt(discountAmount) : 0),
          "discount2": isSubscription ? 0 : (propsDetail.discountcount ? propsDetail.discountcount : 0),
          'is_subscription_price': propsDetail.camperprice,
          'camper_id': propsDetail.id,
          "lng": i18n.resolvedLanguage,
          "request_data": userdata
        }
        console.log(stripedata, "stripedata");

        var checkCamperAvailabilityData = {
          camper_id: propsDetail.id,
          start_date: startDate + ' ' + propsDetail.pickup + ":00",
          end_date: endDate + ' ' + propsDetail.return + ":00",
        }

        var checkCamperAvailabilityDataResp = await PaymentService.checkCamperAvailability(checkCamperAvailabilityData).json();
        
        if(checkCamperAvailabilityDataResp.success){
          var resp = await PaymentService.stripCheckout(stripedata).json();
          localStorage.setItem("stripesession", JSON.stringify(resp.data));
          localStorage.setItem("stripedata", JSON.stringify(userdata));
          setIsSubmitPayment(false);
          // window.location.href = resp.url
          window.location.replace(resp.url)
        } else {
          if (i18n.resolvedLanguage == 'en') {
            setError(checkCamperAvailabilityDataResp.message);
            setIsSubmitPayment(false);
            return;
          } else {
            setError(checkCamperAvailabilityDataResp.german_message);
            setIsSubmitPayment(false);
            return;
          }
        }
      }
    } catch (error) {
      console.log(error)
      if (error.name === 'HTTPError') {
        setIsSubmitPayment(false);
        const errorJson = await error.response.json();
        setErrorMessage(errorJson.message)
      }
    }
  }
  const handleVoucherCode = async (e) => {
    const isSubscription = propsDetail.type === "Subscription";
    const hasBreakdown = isSubscription && Array.isArray(propsDetail.monthlyBreakdown) && propsDetail.monthlyBreakdown.length > 0;
    const breakdownSum = hasBreakdown
      ? Math.round(propsDetail.monthlyBreakdown.reduce((sum, m) => sum + (m.price ?? 0), 0))
      : 0;
    const correctTotalPrice = hasBreakdown ? breakdownSum : Math.round(propsDetail.totalPackages);

    var voucherdata = {
      'email': propsPersonal.email,
      'code': vouchercode,
      "total_price": correctTotalPrice,
      "start_date": moment(startDate).format("YYYY-MM-DD"),
      "end_date": moment(endDate).format("YYYY-MM-DD"),


    }

    console.log(voucherdata)
    var data = await PaymentService.checkvoucher(voucherdata).json()
    if (data.msg === "Voucher alraedy used!!!") {
      setVoucherMessage(t("Voucher.Voucher alraedy used!!!"))
    }
    else if (data.msg === "Voucher applied Successfully!!!") {
      setVoucherMessage(t("Voucher.Voucher applied Successfully!!!"))
    }
    else if (data.msg === "Voucher Not Found!!!") {
      setVoucherMessage(t("Voucher.Voucher Not Found!!!"))
    }
    else if (data.msg === "This discount is only valid for bookings made within the specified time frame.") {
      setVoucherMessage(t("Voucher.This discount is only valid for bookings made within the specified time frame."))
    }
    else {
      setVoucherMessage(data.msg)
    }

    setDiscountAmount(data.discount)

    if (data.is_valid == 1) {
      setIsvalidVoucher(true)
    }
  }
  var servicenewArray = propsDetail && propsDetail.servicePackages.map((element) => {
    return (
      element.price
    )
  })
  let sum = servicenewArray.length != 0 ? servicenewArray.reduce((accumulator, current) => accumulator + current) : 0;

  var accessorynewarray = propsDetail && propsDetail.AccessoriesPackages
    .map((element) => {
      return (
        element.price
      )
    })
  let accessorsum = accessorynewarray.length != 0 ? accessorynewarray.reduce((accumulator, current) => accumulator + current) : 0;
  var kilometerpackagenewarray = propsDetail && propsDetail.kilometerpackage
    .map((element) => {
      return (
        element.price
      )
    })
  let kilosum = kilometerpackagenewarray.length != 0 ? kilometerpackagenewarray.reduce((accumulator, current) => accumulator + current) :
    0;
  {
    if (sessionex === false) {
      console.log("expiretime")
      localStorage.removeItem("propsPersonal");
      localStorage.removeItem("detailData");
      navigate("/")
    }
  };

  const monthlyBreakdown = useMemo(() => {
    if (!propsDetail || propsDetail.type !== "Subscription") return [];
    if (!propsDetail.monthlyBreakdown || propsDetail.monthlyBreakdown.length === 0) return [];

    const numMonths = propsDetail.monthlyBreakdown.length;
    const voucherPerMonth = discountAmount > 0 ? parseInt(discountAmount) / numMonths : 0;

    return propsDetail.monthlyBreakdown.map((month) => ({
      ...month,
      price: Math.max(0, Math.round(month.price - voucherPerMonth)),
    }));
  }, [propsDetail, discountAmount]);

  const normalizeTime = (t) => {
    if (!t) return null;
    if (t.includes(":")) return t;
    return `${String(t).padStart(2, "0")}:00`;
  };

  return (
    <>
      <div className="relative flex flex-col min-h-screen font-brand pb-16 xl:pb-0 bg-off-white">
        <div className="py-4 h-20 bg-white shadow xl:mb-5">
          <div className="flex items-center h-full xl:mx-auto xl:max-w-7xl">
            <Link to="/" className="flex items-center pl-4 w-1/5 h-11">
              <img
                className="hidden block w-11 h-11 md:hidden"
                src={window.location.origin + '/Images/born-camper-logo.png'}

                alt=""
              />

              <img
                className="hidden h-11 md:block"
                src={window.location.origin + '/Images/born-camper-logo.png'}
                alt=""
              />
              { }
            </Link>
            <div className="flex items-center justify-center w-3/5 xl:items-start">
              <div className="stepper grid-cols4 relative grid gap-y-1.5 grid-flow-col grid-rows-2 justify-items-center w-5/6 md:w-3/4 configuration-channel">
                <button className="step relative w-full">
                  <div className="fw-500 mx-auto w-6 h-6 text-center text-secondary small-text border-2px rounded-full border-primary">
                    <svg className="w-full h-full" width="32" height="32">
                      <svg
                        fill="#163435"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 50 50"
                        width="17px"
                        height="17px"
                      >
                        <path d="M 41.9375 8.625 C 41.273438 8.648438 40.664063 9 40.3125 9.5625 L 21.5 38.34375 L 9.3125 27.8125 C 8.789063 27.269531 8.003906 27.066406 7.28125 27.292969 C 6.5625 27.515625 6.027344 28.125 5.902344 28.867188 C 5.777344 29.613281 6.078125 30.363281 6.6875 30.8125 L 20.625 42.875 C 21.0625 43.246094 21.640625 43.410156 22.207031 43.328125 C 22.777344 43.242188 23.28125 42.917969 23.59375 42.4375 L 43.6875 11.75 C 44.117188 11.121094 44.152344 10.308594 43.78125 9.644531 C 43.410156 8.984375 42.695313 8.589844 41.9375 8.625 Z" />
                      </svg>
                    </svg>
                  </div>
                </button>
                <div className="fw-500 text-center text-secondary hidden xl:block">
                  {t("Rent.Select model")}
                </div>
                <button className="step relative w-full">
                  <div className="fw-500 mx-auto w-6 h-6 text-center text-secondary small-text border-2px rounded-full border-primary">
                    <svg className="w-full h-full" width="32" height="32">
                      <svg
                        fill="#163435"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 50 50"
                        width="17px"
                        height="17px"
                      >
                        <path d="M 41.9375 8.625 C 41.273438 8.648438 40.664063 9 40.3125 9.5625 L 21.5 38.34375 L 9.3125 27.8125 C 8.789063 27.269531 8.003906 27.066406 7.28125 27.292969 C 6.5625 27.515625 6.027344 28.125 5.902344 28.867188 C 5.777344 29.613281 6.078125 30.363281 6.6875 30.8125 L 20.625 42.875 C 21.0625 43.246094 21.640625 43.410156 22.207031 43.328125 C 22.777344 43.242188 23.28125 42.917969 23.59375 42.4375 L 43.6875 11.75 C 44.117188 11.121094 44.152344 10.308594 43.78125 9.644531 C 43.410156 8.984375 42.695313 8.589844 41.9375 8.625 Z" />
                      </svg>
                    </svg>
                  </div>
                </button>
                <div className="fw-500 text-center text-secondary hidden xl:block xl:text-opacity-disabled">
                  {t("Rent.Configuration")}
                </div>
                <button className="step relative w-full">
                  <div className="fw-500 mx-auto w-6 h-6 text-center text-secondary small-text border-2px rounded-full border-primary">
                    <svg className="w-full h-full" width="32" height="32">
                      <svg
                        fill="#163435"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 50 50"
                        width="17px"
                        height="17px"
                      >
                        <path d="M 41.9375 8.625 C 41.273438 8.648438 40.664063 9 40.3125 9.5625 L 21.5 38.34375 L 9.3125 27.8125 C 8.789063 27.269531 8.003906 27.066406 7.28125 27.292969 C 6.5625 27.515625 6.027344 28.125 5.902344 28.867188 C 5.777344 29.613281 6.078125 30.363281 6.6875 30.8125 L 20.625 42.875 C 21.0625 43.246094 21.640625 43.410156 22.207031 43.328125 C 22.777344 43.242188 23.28125 42.917969 23.59375 42.4375 L 43.6875 11.75 C 44.117188 11.121094 44.152344 10.308594 43.78125 9.644531 C 43.410156 8.984375 42.695313 8.589844 41.9375 8.625 Z" />
                      </svg>
                    </svg>
                  </div>
                </button>
                <div className="fw-500 text-center text-secondary hidden xl:block xl:text-opacity-disabled">
                  {t("Rent.Details")}
                </div>
                <button className="step relative w-full activeStep">
                  <div className="mx-auto w-6 h-6 text-center text-secondary small-text border-2px fw-500 rounded-full border-primary">
                    4
                  </div>
                </button>
                <div className="fw-500 text-center text-secondary col-span-full row-start-2 xl:col-auto">
                  {t("Rent.Payment")}
                </div>
              </div>
            </div>

          </div>
        </div>
        <main className="flex-grow xl:mb-64 mb-5">
          <h2 className="fw-500 mb-4 mt-8 w-full text-center text-3xl">{t("Rent.Your offer")}</h2>
          <div className="w-full max-w-5xl lg:mx-auto xl:flex">

            <div className="md:mx-0 mx-6 max-w-xl md:mx-auto xl:ml-3 xl:mr-0 xl:w-1/2">

              <div className="aspect-w-2 aspect-h-1 w-full">
                <img
                  className="-mb-8 w-full h-full object-contain object-bottom"
                  src={imageUrl + propsDetail.camperimage}
                  alt="side-detail-img"
                />
                {/* <img className="-mb-8 w-full h-full object-contain object-bottom" src="/Images/detail-image.png" alt="side-detail-img" /> */}
              </div>

              <div className="bg-white rounded-button shadow rounded divide-secondary divide-opacity-disabled divide-y overflow-hidden xl:rounded-3xl -mt-10 md:pt-10 pt-5 divide-y-0">
                <div className="flex flex-col items-center md:p-6 p-3">
                  <span className="fw-500 text-center"></span>
                  <h3 className="fw-500 break-words text-3xl text-center mb-3">{propsDetail.title}</h3>

                  <div className="grid gap-4 grid-cols-2 mt-2 w-full full-width-grid">



                    {/* Start Date */}
                    <div className="text-center">
                      <h4 className="mt-1 text-center">
                        {t("Rent.Start-Date")}
                      </h4>
                      <div className="custom-sm-width relative flex items-center px-2 h-12 border border-secondary border-opacity-disabled rounded flex items-center justify-between w-full">

                        <svg className="h-7 w-7" width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 7V12L14.5 13.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        <span className="fw-500 flex-grow text-center">{moment(dateSelected[0]).format('DD/MM/YYYY')} {normalizeTime(propsDetail.pickup)}</span>
                      </div>
                    </div>

                    {/* End Date */}
                    <div className="text-center md-mb-0 mb-2">
                      <h4 className="mt-1 text-center">
                        {t("Rent.End-Date")}
                      </h4>
                      <div className="custom-sm-width relative flex items-center px-2 h-12 border border-secondary border-opacity-disabled rounded flex items-center justify-between w-full">

                        <svg className="h-7 w-7" width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 7V12L14.5 13.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        <span className="fw-500 flex-grow text-center">{moment(dateSelected[1]).format('DD/MM/YYYY')} {normalizeTime(propsDetail.return)}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="md:p-6 p-3 bg-off-white max-h-[420px] overflow-y-auto revised-sm-size">
                  <div className="grid md:gap-y-0 gap-y-0 font-light custom-grid">
                    {propsDetail.type !== "Subscription" && (
                      <svg className="w-7 h-7 cssvar-secondary-to-primary" width="32" height="32"><svg viewBox="0 0 32 32" fill="none" id="icon-check-circle"><path fillRule="evenodd" clipRule="evenodd" d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10.7533 16.2181C11.0708 15.7706 11.6483 15.7117 12.0431 16.0865L14.2653 18.1963L19.6446 11.4402C19.9837 11.0144 20.5638 10.9928 20.9402 11.3921C21.3167 11.7914 21.347 12.4603 21.0079 12.8862L15.0481 20.3715C14.7223 20.7806 14.1708 20.8189 13.7915 20.4588L10.8933 17.7072C10.4984 17.3323 10.4358 16.6656 10.7533 16.2181Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg>
                      </svg>
                    )}

                    {/* Monthly Price Breakdown */}
                    {propsDetail.type == "Subscription" &&
                      monthlyBreakdown?.map((month) => (
                        <Fragment key={`month-${month.index}`}>
                          <svg
                            className="w-7 h-7 cssvar-secondary-to-primary"
                            width="32"
                            height="32"
                          >
                            <svg
                              viewBox="0 0 32 32"
                              fill="none"
                              id="icon-check-circle"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10.7533 16.2181C11.0708 15.7706 11.6483 15.7117 12.0431 16.0865L14.2653 18.1963L19.6446 11.4402C19.9837 11.0144 20.5638 10.9928 20.9402 11.3921C21.3167 11.7914 21.347 12.4603 21.0079 12.8862L15.0481 20.3715C14.7223 20.7806 14.1708 20.8189 13.7915 20.4588L10.8933 17.7072C10.4984 17.3323 10.4358 16.6656 10.7533 16.2181Z"
                                fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                              ></path>
                            </svg>
                          </svg>

                          {/* Month label */}
                          <div className="font-semibold text-[18px]">
                            {month.index}. 
                            {i18n.resolvedLanguage === "de" ? "Monat" : "Month"} {" "}
                            {propsDetail?.discountPercentage > 0 && `(-${propsDetail?.discountPercentage}%)`}
                          </div>

                          <div className="justify-self-center"></div>

                          {/* Month price */}
                          <div className="justify-self-end font-semibold text-[18px] price-font">
                            <NumericFormat
                              value={month.price}
                              thousandSeparator="."
                              decimalSeparator=","
                              displayType="text"
                            /> €
                          </div>
                        </Fragment>
                      ))
                    }

                    {propsDetail.type !== "Subscription" && (
                      propsDetail.camperprice ?
                        <>
                          <div className="flex">{propsDetail.title}</div>
                          <div className="justify-self-center"></div>
                          <div className="justify-self-end font-normal price-font">
                            <NumericFormat
                              value={propsDetail.camperprice}
                              thousandSeparator={'.'}
                              decimalSeparator={','}
                              displayType={'text'}
                            />
                            €
                          </div>
                        </>
                        :
                        <>
                          {propsDetail.type == "Rent" ?
                            <div className="flex br-none">
                              {propsDetail.title}<br /> {propsDetail.days ? " - " + propsDetail.days + " " + t("Rent.Nights") + " " : ''}
                            </div>
                            :
                            <div className="flex">
                              {propsDetail.title} {propsDetail.days ? " - " + differenceMonth + " " + t("Rent.Months") + " " : ''}
                            </div>
                          }

                          <div className="justify-self-center"></div>

                          {propsDetail.discountcount != 0 ?
                            <div className="justify-self-end font-normal price-font">
                              <NumericFormat

                                value={Math.round(propsDetail.totalCamperPrice)}
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                displayType={'text'}

                              />€
                            </div>
                            :
                            <div className="justify-self-end font-normal price-font">
                              <NumericFormat
                                value={parseInt(propsDetail.totalCamperPrice)}
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                displayType={'text'}
                              />
                              €
                            </div>
                          }
                        </>
                    )}

                    {propsDetail.serviceFee === "0" ?
                      <></>
                      :
                      <>
                        <svg className="w-7 h-7 cssvar-secondary-to-primary" width="32" height="32">
                          <svg viewBox="0 0 32 32" fill="none" id="icon-check-circle"><path fillRule="evenodd" clipRule="evenodd" d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10.7533 16.2181C11.0708 15.7706 11.6483 15.7117 12.0431 16.0865L14.2653 18.1963L19.6446 11.4402C19.9837 11.0144 20.5638 10.9928 20.9402 11.3921C21.3167 11.7914 21.347 12.4603 21.0079 12.8862L15.0481 20.3715C14.7223 20.7806 14.1708 20.8189 13.7915 20.4588L10.8933 17.7072C10.4984 17.3323 10.4358 16.6656 10.7533 16.2181Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg>
                        </svg>
                        <div>{t("Rent.Service fee")}</div>
                        <div className="justify-self-center"></div>
                        {propsDetail.type !== "Subscription" ?
                          <div className="ml-auto justify-self-end font-normal price-font">{propsDetail.serviceFee || 0}€</div>
                          :
                          <div className="ml-auto justify-self-end font-normal price-font"></div>
                        }
                      </>
                    }

                    {propsDetail.packages.map((element) => {
                      return (
                        <>
                          <svg className="w-7 h-7 cssvar-secondary-to-primary" width="32" height="32"><svg viewBox="0 0 32 32" fill="none" id="icon-check-circle"><path fillRule="evenodd" clipRule="evenodd" d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10.7533 16.2181C11.0708 15.7706 11.6483 15.7117 12.0431 16.0865L14.2653 18.1963L19.6446 11.4402C19.9837 11.0144 20.5638 10.9928 20.9402 11.3921C21.3167 11.7914 21.347 12.4603 21.0079 12.8862L15.0481 20.3715C14.7223 20.7806 14.1708 20.8189 13.7915 20.4588L10.8933 17.7072C10.4984 17.3323 10.4358 16.6656 10.7533 16.2181Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg>
                          </svg>

                          {propsDetail.type == "Rent" ?
                            <div className="flex br-none">
                              {element.title}<br /> {propsDetail.days ? " - " + propsDetail.days + " " + t("Rent.Nights") + " " : ''}
                            </div>
                            :
                            <div className="flex br-none">
                              {element.title} <br /> {propsDetail.days ? " - " + propsDetail.days + " " + t("Rent.Months") + " " : ''}
                            </div>
                          }
                          <div className="justify-self-center"> </div>
                          <div className="justify-self-end font-normal price-font">
                            <NumericFormat
                              value={propsDetail.days ? propsDetail.days * element.price : element.price}
                              thousandSeparator={'.'}
                              decimalSeparator={','}
                              displayType={'text'}

                            />€
                          </div>
                        </>
                      )
                    })}

                    {propsDetail.cancelpackages.map((element) => {
                      return (<>
                        <svg
                          className="w-7 h-7 cssvar-secondary-to-primary"
                          width="32"
                          height="32"
                        >
                          <svg
                            viewBox="0 0 32 32"
                            fill="none"
                            id="icon-check-circle"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10.7533 16.2181C11.0708 15.7706 11.6483 15.7117 12.0431 16.0865L14.2653 18.1963L19.6446 11.4402C19.9837 11.0144 20.5638 10.9928 20.9402 11.3921C21.3167 11.7914 21.347 12.4603 21.0079 12.8862L15.0481 20.3715C14.7223 20.7806 14.1708 20.8189 13.7915 20.4588L10.8933 17.7072C10.4984 17.3323 10.4358 16.6656 10.7533 16.2181Z"
                              fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                            ></path>
                          </svg>
                        </svg>

                        {propsDetail.type == "Rent" ?
                          <div className="flex br-none">
                            {element.title} <br /> {propsDetail.days ? " - " + propsDetail.days + " " + t("Rent.Nights") + " " : ''}
                          </div>
                          :
                          <div className="flex br-none">
                            {element.title} <br /> {propsDetail.days ? " - " + propsDetail.days + " " + t("Rent.Months") + " " : ''}
                          </div>
                        }
                        <div className="justify-self-center"></div>
                        <div className="justify-self-end font-normal price-font">
                          <NumericFormat
                            value={propsDetail.days ? propsDetail.days * element.price : element.price}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            displayType={'text'}
                          />
                          €
                        </div>
                      </>
                      )
                    })}

                    {propsDetail.servicePackages.map((element) => {
                      return (
                        <Fragment>
                          <svg
                            className="w-7 h-7 cssvar-secondary-to-primary"
                            width="32"
                            height="32"
                          >
                            <svg
                              viewBox="0 0 32 32"
                              fill="none"
                              id="icon-check-circle"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10.7533 16.2181C11.0708 15.7706 11.6483 15.7117 12.0431 16.0865L14.2653 18.1963L19.6446 11.4402C19.9837 11.0144 20.5638 10.9928 20.9402 11.3921C21.3167 11.7914 21.347 12.4603 21.0079 12.8862L15.0481 20.3715C14.7223 20.7806 14.1708 20.8189 13.7915 20.4588L10.8933 17.7072C10.4984 17.3323 10.4358 16.6656 10.7533 16.2181Z"
                                fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                              ></path>
                            </svg>
                          </svg>

                          {propsDetail.type === "Subscription" ?
                            <>
                              {element.type === 0
                                // element.title == "Interior cleaning" || element.title === "Innenreinigung" || element.title == "Dog camper" || element.title === "Hunde Camper" || element.title == "Shuttle Service" || element.title == "Abhol-Service"
                                ?
                                <>
                                  <div className="flex">{element.title} </div>

                                  <div className="justify-self-center"> </div>
                                  <div className="justify-self-end font-normal price-font">
                                    {/* <NumericFormat
                                      value={element.price}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType={'text'}
                                    />€ */}
                                  </div>
                                </>
                                :
                                <>
                                  {propsDetail.type == "Rent" ?
                                    <div className="flex br-none">
                                      {element.title} <br /> {propsDetail.days ? " - " + propsDetail.days + " " + t("Rent.Nights") + " " : ''}
                                    </div>
                                    :
                                    <div className="flex br-none">
                                      {element.title} <br /> 
                                      {/* {differenceMonth ? " - " + differenceMonth + " " + t("Rent.Months") + " " : ''} */}
                                    </div>
                                  }
                                  <div className="justify-self-center"> </div>
                                  <div className="justify-self-end font-normal price-font">
                                    {/* <NumericFormat
                                      value={propsDetail.days ? propsDetail.days * element.price : element.price}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType={'text'}
                                    />€ */}
                                  </div>
                                </>
                              }
                            </>
                            :
                            <>
                              {propsDetail.type == "Rent" ?
                                <div className="flex br-none">
                                  {element.title} <br /> {propsDetail.days ? " - " + propsDetail.days + " " + t("Rent.Nights") + " " : ''}
                                </div>
                                :
                                <div className="flex br-none">
                                  {element.title} <br /> 
                                  {/* {differenceMonth ? " - " + differenceMonth + " " + t("Rent.Months") + " " : ''} */}
                                </div>
                              }

                              <div className="justify-self-center"> </div>
                              <div className="justify-self-end font-normal price-font">
                                <NumericFormat
                                  value={propsDetail.days ? propsDetail.days * element.price : element.price}
                                  thousandSeparator={'.'}
                                  decimalSeparator={','}
                                  displayType={'text'}
                                />
                                €
                              </div>
                            </>
                          }

                          {/* <div>{element.title} {" - " + propsDetail.days + ' Nights'}</div>
                        <div className="justify-self-center"></div>
                        <div className="justify-self-end font-normal price-font">
                          <NumericFormat
                            value={propsDetail.days ? propsDetail.days * element.price : element.price}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            displayType={'text'}

                          />
                          € </div> */}
                        </Fragment>
                      )
                    })}

                    {propsDetail.servicePackagesFix.map((element) => {
                      return (
                        <Fragment>
                          <svg
                            className="w-7 h-7 cssvar-secondary-to-primary"
                            width="32"
                            height="32"
                          >
                            <svg
                              viewBox="0 0 32 32"
                              fill="none"
                              id="icon-check-circle"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10.7533 16.2181C11.0708 15.7706 11.6483 15.7117 12.0431 16.0865L14.2653 18.1963L19.6446 11.4402C19.9837 11.0144 20.5638 10.9928 20.9402 11.3921C21.3167 11.7914 21.347 12.4603 21.0079 12.8862L15.0481 20.3715C14.7223 20.7806 14.1708 20.8189 13.7915 20.4588L10.8933 17.7072C10.4984 17.3323 10.4358 16.6656 10.7533 16.2181Z"
                                fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                              ></path>
                            </svg>
                          </svg>
                          <div className="flex">{element.title} </div>
                          <div className="justify-self-center"></div>
                          <div className="justify-self-end font-normal price-font">
                            <NumericFormat
                              value={element.price}
                              thousandSeparator={'.'}
                              decimalSeparator={','}
                              displayType={'text'}
                            />€
                          </div>
                        </Fragment>
                      )
                    })}

                    {propsDetail.AccessoriesPackages.map((element) => {
                      return (
                        <>
                          <svg
                            className="w-7 h-7 cssvar-secondary-to-primary"
                            width="32"
                            height="32"
                          >
                            <svg
                              viewBox="0 0 32 32"
                              fill="none"
                              id="icon-check-circle"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10.7533 16.2181C11.0708 15.7706 11.6483 15.7117 12.0431 16.0865L14.2653 18.1963L19.6446 11.4402C19.9837 11.0144 20.5638 10.9928 20.9402 11.3921C21.3167 11.7914 21.347 12.4603 21.0079 12.8862L15.0481 20.3715C14.7223 20.7806 14.1708 20.8189 13.7915 20.4588L10.8933 17.7072C10.4984 17.3323 10.4358 16.6656 10.7533 16.2181Z"
                                fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                              ></path>
                            </svg>
                          </svg>

                          {propsDetail.type == "Rent" ?
                            <div className="flex br-none">
                              {element.title} <br /> {propsDetail.days ? " - " + propsDetail.days + " " + t("Rent.Nights") + " " : ''}
                            </div>
                            :
                            element.type === 0 ?
                              <div className="flex br-none">
                                {element.title}
                              </div>
                              :
                              <div className="flex br-none">
                                {element.title}<br /> 
                                {/* {propsDetail.days ? " - " + propsDetail.days + " " + t("Rent.Months") + " " : ''} */}
                              </div>
                          }
                          <div className="justify-self-center"></div>
                          <div className="justify-self-end font-normal price-font">
                            {propsDetail.type == "Rent" && 
                              <>
                                <NumericFormat
                                  value={propsDetail.days ? propsDetail.days * element.price : element.price}
                                  thousandSeparator={'.'}
                                  decimalSeparator={','}
                                  displayType={'text'}
                                />
                                €
                              </>
                            }
                          </div>
                        </>
                      )
                    })}

                    {propsDetail.AccessoriesPackagesFix && propsDetail.AccessoriesPackagesFix.map((element) => {
                      return (
                        <>
                          <svg
                            className="w-7 h-7 cssvar-secondary-to-primary"
                            width="32"
                            height="32"
                          >
                            <svg
                              viewBox="0 0 32 32"
                              fill="none"
                              id="icon-check-circle"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10.7533 16.2181C11.0708 15.7706 11.6483 15.7117 12.0431 16.0865L14.2653 18.1963L19.6446 11.4402C19.9837 11.0144 20.5638 10.9928 20.9402 11.3921C21.3167 11.7914 21.347 12.4603 21.0079 12.8862L15.0481 20.3715C14.7223 20.7806 14.1708 20.8189 13.7915 20.4588L10.8933 17.7072C10.4984 17.3323 10.4358 16.6656 10.7533 16.2181Z"
                                fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                              ></path>
                            </svg>
                          </svg>
                          <div className="flex">{element.title} </div>
                          <div className="justify-self-center"></div>
                          <div className="justify-self-end font-normal price-font">
                            <NumericFormat
                              value={element.price}
                              thousandSeparator={'.'}
                              decimalSeparator={','}
                              displayType={'text'}
                            />€
                          </div>
                        </>
                      )
                    })}

                    {propsDetail.kilometerpackage && propsDetail.kilometerpackage.map((element) => {
                      return (<>
                        <svg
                          className="w-7 h-7 cssvar-secondary-to-primary"
                          width="32"
                          height="32"
                        >
                          <svg
                            viewBox="0 0 32 32"
                            fill="none"
                            id="icon-check-circle"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10.7533 16.2181C11.0708 15.7706 11.6483 15.7117 12.0431 16.0865L14.2653 18.1963L19.6446 11.4402C19.9837 11.0144 20.5638 10.9928 20.9402 11.3921C21.3167 11.7914 21.347 12.4603 21.0079 12.8862L15.0481 20.3715C14.7223 20.7806 14.1708 20.8189 13.7915 20.4588L10.8933 17.7072C10.4984 17.3323 10.4358 16.6656 10.7533 16.2181Z"
                              fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                            ></path>
                          </svg>
                        </svg>
                        <div className="flex br-none">{element.title} &nbsp;{t("subscription.per Month")} <br />
                          {/* {propsDetail.days ? " - " + propsDetail.days + " " + t("Rent.Months") + " " : ''} */}
                        </div>
                        <div className="justify-self-center"> </div>
                        <div className="justify-self-end font-normal price-font">
                          {/* <NumericFormat
                          value={propsDetail.days ? propsDetail.days * element.price : element.price}
                          thousandSeparator={'.'}
                          decimalSeparator={','}
                          displayType={'text'}
                        /> € */}
                        </div>
                      </>)
                    })}

                    {(propsDetail.type == "Subscription" && propsDetail?.discountPercentage > 0) && (
                      <>
                        <svg className="w-7 h-7 cssvar-secondary-to-primary" width="32" height="32">
                          <svg viewBox="0 0 32 32" fill="none" id="icon-check-circle"><path fillRule="evenodd" clipRule="evenodd" d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10.7533 16.2181C11.0708 15.7706 11.6483 15.7117 12.0431 16.0865L14.2653 18.1963L19.6446 11.4402C19.9837 11.0144 20.5638 10.9928 20.9402 11.3921C21.3167 11.7914 21.347 12.4603 21.0079 12.8862L15.0481 20.3715C14.7223 20.7806 14.1708 20.8189 13.7915 20.4588L10.8933 17.7072C10.4984 17.3323 10.4358 16.6656 10.7533 16.2181Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg>
                        </svg>
                        <div className="flex" style={{ whiteSpace: "nowrap" }}>{t("Rent.Long term discount")} (-{propsDetail?.discountPercentage}%)</div>
                        <div className="justify-self-center"></div>
                        <div className="justify-self-end font-normal price-font">
                          {/* -{Math.round(propsDetail.discountcount)} € */}
                        </div>
                      </>
                    )}

                    {propsDetail.type != "Subscription" &&
                    propsDetail.days >= 8 && propsDetail.days < 15 ?
                      <>
                        <svg className="w-7 h-7 cssvar-secondary-to-primary" width="32" height="32">
                          <svg viewBox="0 0 32 32" fill="none" id="icon-check-circle"><path fillRule="evenodd" clipRule="evenodd" d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10.7533 16.2181C11.0708 15.7706 11.6483 15.7117 12.0431 16.0865L14.2653 18.1963L19.6446 11.4402C19.9837 11.0144 20.5638 10.9928 20.9402 11.3921C21.3167 11.7914 21.347 12.4603 21.0079 12.8862L15.0481 20.3715C14.7223 20.7806 14.1708 20.8189 13.7915 20.4588L10.8933 17.7072C10.4984 17.3323 10.4358 16.6656 10.7533 16.2181Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg>
                        </svg>
                        <div className="flex">{t("Rent.5% Long term discount")}</div>
                        <div className="justify-self-center"></div>
                        <div className="justify-self-end font-normal price-font">-{Math.round(propsDetail.discountcount)} €</div>

                      </>
                      :
                      propsDetail.days >= 15 && propsDetail.days < 22 ?
                        <>
                          <svg className="w-7 h-7 cssvar-secondary-to-primary" width="32" height="32">
                            <svg viewBox="0 0 32 32" fill="none" id="icon-check-circle"><path fillRule="evenodd" clipRule="evenodd" d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10.7533 16.2181C11.0708 15.7706 11.6483 15.7117 12.0431 16.0865L14.2653 18.1963L19.6446 11.4402C19.9837 11.0144 20.5638 10.9928 20.9402 11.3921C21.3167 11.7914 21.347 12.4603 21.0079 12.8862L15.0481 20.3715C14.7223 20.7806 14.1708 20.8189 13.7915 20.4588L10.8933 17.7072C10.4984 17.3323 10.4358 16.6656 10.7533 16.2181Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg>
                          </svg>
                          <div className="flex">{t("Rent.10% Long term discount")}</div>
                          <div className="justify-self-center"></div>
                          <div className="justify-self-end font-normal price-font">-{Math.round(propsDetail.discountcount)} €</div>
                        </>
                        :
                        propsDetail.days >= 22 ?
                          <>
                            <svg className="w-7 h-7 cssvar-secondary-to-primary" width="32" height="32">
                              <svg viewBox="0 0 32 32" fill="none" id="icon-check-circle"><path fillRule="evenodd" clipRule="evenodd" d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10.7533 16.2181C11.0708 15.7706 11.6483 15.7117 12.0431 16.0865L14.2653 18.1963L19.6446 11.4402C19.9837 11.0144 20.5638 10.9928 20.9402 11.3921C21.3167 11.7914 21.347 12.4603 21.0079 12.8862L15.0481 20.3715C14.7223 20.7806 14.1708 20.8189 13.7915 20.4588L10.8933 17.7072C10.4984 17.3323 10.4358 16.6656 10.7533 16.2181Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg>
                            </svg>
                            <div className="flex">{t("Rent.15% Long term discount")}</div>
                            <div className="justify-self-center"></div>
                            <div className="justify-self-end font-normal price-font">-{Math.round(propsDetail.discountcount)} €</div>
                          </>
                          : ''
                    }
                  </div>
                </div>

                <div className="flex flex-col items-center md:p-6 p-3">
                  <div className="items-center w-full font-light">
                    {/* <form className="col-span-2 w-full" onSubmit={handleVoucherCode}> */}
                    {propsDetail.camper_type_id}
                    <div className="col-span-2 w-full relative">
                      <input className="d-none" hidden="" readOnly="" name="lang" value="" />
                      <input id="sidepanel-coupon" type="checkbox" hidden="" name="coupon" className="peer" data-gtm-form-interact-field-id="5"></input>
                      <label for="sidepanel-coupon" className="cursor-pointer peer-checked:hidden inline-block w-7 h-7 border border-secondary group-hover:border-primary border-opacity-disabled rounded-full float-left mr-4"></label>
                      <svg className="peer-checked:block hidden w-7 h-7 cssvar-secondary-to-white bg-primary rounded-full float-left mr-4" width="32" height="32"><svg viewBox="0 0 32 32" fill="none" id="icon-check"><path fillRule="evenodd" clipRule="evenodd" d="M21.906 9.48846L13.359 19.0475L9.90893 15.9522C9.14392 15.2659 7.99291 15.3597 7.34557 16.1608C6.70507 16.9533 6.79855 18.1407 7.55541 18.8197L12.3198 23.0941C13.0547 23.7534 14.1534 23.6963 14.8159 22.9643L24.5455 12.0952C25.2268 11.3424 25.1965 10.1517 24.4772 9.42988C23.7501 8.70042 22.5956 8.72641 21.906 9.48846Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg></svg>
                      <div className="inline-block h-10"><label for="sidepanel-coupon">{t("Rent.I have a voucher code")}</label></div>
                      <div className="relative z-10 peer-checked:grid hidden grid-cols-2 w-full h-11">
                        <div className="flex items-center justify-center px-4 w-full border border-r-0 focus-within:border-primary rounded-l border-secondary border-opacity-disabled">
                          <div className="flex-grow">
                            <input type="text" onChange={e => setCode(e.target.value)} name="code" className="w-full text-lg outline-none caret-primary" />
                          </div>
                        </div>
                        <button className="grid-cols1 inline-grid grid-rows-1 px-4 w-full h-full text-white font-normal rounded-r bg-secondary hover:bg-primary" onClick={handleVoucherCode}>
                          <span className="relative flex col-start-1 row-start-1 items-center justify-between w-full h-full transition-opacity duration-300">
                            <span className="transform transition-transform duration-300 flex-grow grid place-items-center translate-x-0">
                              <span className="text-20">{t("Rent.Apply code")}</span>
                            </span>
                          </span>
                        </button>
                      </div>
                    </div>
                    {/* </form> */}

                    <div className="text-center text-20 md:mt-5 mt-4 mb-2">
                      <h4>{voucherMessage}</h4>
                    </div>

                    {propsDetail.type == "Rent" ?
                      <>
                        {/* <div className="max-w-full">
                          <div className="flex gap-3 rounded-xl bg-blue-50 px-4 py-3 shadow-sm">
                            <div className="flex h-7 w-7 shrink-0 items-center justify-center">
                              <img
                                className="h-4 w-4"
                                src="/svg-icon/lock.svg"
                                alt="Info Icon"
                              />
                            </div>
                            <div className="flex flex-col gap-1 w-full text-xs">
                              <div className="flex items-center justify-between gap-4">
                                <span className="text-gray-700 whitespace-nowrap">
                                  Picking up earlier than <strong>14:00</strong>
                                </span>
                                <span className="font-semibold text-gray-900 whitespace-nowrap">
                                  +€7 <span className="font-normal text-gray-600">/ 30 min</span>
                                </span>
                              </div>

                              <div className="flex items-center justify-between gap-4">
                                <span className="text-gray-700 whitespace-nowrap">
                                  Returning later than <strong>11:00</strong>
                                </span>
                                <span className="font-semibold text-gray-900 whitespace-nowrap">
                                  +€7 <span className="font-normal text-gray-600">/ 30 min</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div> */}

                        <div className="md:mt-3 mt-0 justify-self-center text-4xl font-normal price-font fw-600 text-center">
                          <NumericFormat
                            value={Math.round(
                              propsDetail.totalPackages +
                              (propsDetail.pickup_charge ?? 0) +
                              (propsDetail.return_charge ?? 0)
                            )}
                            // value={Math.round(propsDetail.totalPackages -propsDetail.discountcount)}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            displayType={'text'}
                          />€
                        </div>
                        <h4 className="md:py-4 py-0 text-md  text-center text-md font-normal">{t("Rent.Total incl. Vat")}</h4>
                      </>
                      :
                      <>
                        {/* <h3 className="justify-self-center  font-normal price-font fw-600 mb-0 text-3xl text-center mobile-font">
                            {
                              propsDetail.type == "Subscription" ?
                                <>
                                  {t("subscription.first month")}:
                                  <NumericFormat
                                    className="ms-1"
                                    // value={Math.round(detailData.totalPackages -propsData.discountcount)}
                                    value={Math.round(propsDetail.camperprice / parseInt(differenceMonth) + parseInt(sum) + parseInt(accessorsum) + parseInt(kilosum)) + parseInt(propsDetail.serviceFee)}
                                    thousandSeparator={'.'}
                                    decimalSeparator={','}
                                    displayType={'text'}

                                  />
                                  €
                                </>
                                :
                                <>
                                  {t("Rent.Per Month")}:
                                  <NumericFormat
                                    className="ms-1"
                                    // value={Math.round(detailData.totalPackages -propsData.discountcount)}
                                    value={Math.round(propsDetail.totalPackages / parseInt(differenceMonth))}
                                    thousandSeparator={'.'}
                                    decimalSeparator={','}
                                    displayType={'text'}

                                  />
                                  €
                                </>
                            }


                          </h3>


                          <div></div>
                          <h4 className="font-normal price-font fw-600 text-center total-text mt-2">

                            {t("Rent.Total")}:&nbsp;
                            <NumericFormat

                              value={propsDetail.totalPackages}
                              thousandSeparator={'.'}
                              decimalSeparator={','}
                              displayType={'text'}

                            />
                            €
                          </h4> */}
                        <div className="max-w-full">
                          <div className="flex items-center gap-2 rounded-xl bg-blue-50 px-4 py-3 shadow-sm">
                            {/* Icon */}
                            <div className="flex h-8 w-8 items-center justify-center">
                              <img
                                className="h-5 w-5 text-yellow-400"
                                src="/svg-icon/lock.svg"
                                alt="Info Icon"
                              />
                            </div>

                            {/* Text */}
                            <p className="info-note text-sm text-gray-700 flex flex-wrap whitespace-normal text-start">
                              {t("Rent.Monthly payment.")}
                              <br />
                              {t("Rent.Full cost transparency from the start.")}
                            </p>
                          </div>
                        </div>
                      </>
                    }
                    {(() => {
                      const isSubscription = propsDetail.type === "Subscription";

                      let toPay = 0;
                      if (isSubscription && monthlyBreakdown.length > 0) {
                        // monthlyBreakdown already has voucher discount distributed per month
                        toPay = monthlyBreakdown.reduce((sum, m) => sum + (m.price ?? 0), 0);
                      } else {
                        // Rental: subtract full voucher from total
                        toPay = Math.max(0,
                          parseInt(propsDetail.totalPackages) +
                          parseInt(propsDetail.pickup_charge || 0) +
                          parseInt(propsDetail.return_charge || 0) -
                          parseInt(discountAmount || 0)
                        );
                      }

                      return discountAmount > 0 ? (
                        <>
                          <div className="text-center text-20 md:mt-5 mt-0">
                            <h4 className="mt-0 font-sizemd-custom fw-400 text-lg-custom">
                              {t("Rent.Discount")}: {discountAmount}€
                            </h4>
                          </div>
                          <div className="text-center text-20 mt-0">
                            <h4 className="text-lg-custom">
                              {t("Rent.To pay")}: &nbsp;{toPay}€
                            </h4>
                          </div>
                        </>
                      ) : null;
                    })()}
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-button shadow rounded divide-secondary divide-opacity-disabled divide-y overflow-hidden xl:rounded-3xl mb-10 mt-10 md:mx-4 mx-0 rounded-3xl sm:mx-0 address-details">
                <details>
                  <summary className="cursor-pointer p-4 text-xl marker:content-none medium-text fw-500">
                    <div className="flex flex-row md:justify-start justify-start md:gap-2 gap-2 items-center">
                      <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z" fill="var(--svg-color-secondary, #163435)"></path></g></svg>
                      <span>{t("Rent.Your address details")}</span>
                    </div>
                  </summary>
                  <div className="p-4 space-y-4">

                    <div className="space-y-2">
                      <div className="flex items-center fw-500">
                        <svg className="mr-2 w-7 h-7" width="32" height="32"><svg viewBox="0 0 32 32" fill="none" id="icon-person"><path fillRule="evenodd" clipRule="evenodd" d="M16 14.6527C13.6105 14.6527 11.6736 12.7158 11.6736 10.3264C11.6736 7.93688 13.6105 6 16 6C18.3895 6 20.3264 7.93688 20.3264 10.3264C20.3264 12.7158 18.3895 14.6527 16 14.6527Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path><path fillRule="evenodd" clipRule="evenodd" d="M16.1565 15.9742C12.2188 15.8883 9 19.0545 9 22.9726C9 23.4621 9.05258 23.9383 9.15042 24.3979C9.26224 24.9247 9.72616 25.3021 10.2643 25.3021H21.7361C22.2693 25.3021 22.7352 24.9324 22.847 24.4112C23.0091 23.6528 23.05 22.8501 22.9329 22.0181C22.4596 18.6482 19.5587 16.0487 16.1565 15.9742Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg></svg>
                        {t("Rent.First & last name")}
                      </div>
                      <div className="font-light">{propsPersonal.name}</div>
                    </div>

                    <div className="space-y-2">
                      <div className="flex items-center fw-500">
                        <svg className="mr-2 w-7 h-7" width="32" height="32"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" id="icon-email"><path fillRule="evenodd" clipRule="evenodd" d="M14.476 27.333C17.811 27.333 20.088 26.229 20.088 25.677C20.088 25.286 19.743 24.389 19.421 24.205C18.34 24.757 16.523 25.263 14.89 25.263C10.566 25.263 7.277 22.112 7.277 16.868C7.277 13.073 10.037 7.162 17.144 7.162C22.871 7.162 24.504 11.095 24.504 13.694C24.504 17.834 22.595 19.904 20.824 19.904C20.088 19.904 19.628 19.467 19.628 18.409C19.628 18.1985 19.6547 17.7412 19.6937 17.2562L19.7298 16.8388C19.7554 16.5629 19.7837 16.2983 19.812 16.086L20.479 11.992C20.226 11.67 19.007 11.509 18.363 11.532C18.3496 11.6393 18.2892 11.958 18.2275 12.3099L18.1754 12.6155C18.1502 12.7682 18.1273 12.9178 18.11 13.05C17.811 12.268 17.029 11.256 15.557 11.256C13.648 11.256 11.026 13.027 11.026 16.937C11.026 19.398 12.314 21.353 14.637 21.353C16.063 21.353 17.052 20.502 17.696 19.605H17.834C18.064 20.824 19.076 21.951 20.732 21.951C23.492 21.951 26.689 19.375 26.689 13.74C26.689 8.358 22.641 5 17.259 5C8.887 5 5 11.486 5 16.96C5 22.848 9.094 27.333 14.476 27.333ZM15.143 19.168C14.223 19.168 13.349 18.524 13.349 16.891C13.349 15.074 14.085 13.395 15.787 13.395C16.776 13.395 17.443 14.476 17.443 15.902C17.443 18.041 16.247 19.168 15.143 19.168Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg></svg>
                        {t("sale.Email")}
                      </div>
                      <div className="font-light">{propsPersonal.email}</div>
                    </div>

                    <div className="space-y-2">
                      <div className="flex items-center fw-500">
                        <svg className="mr-2 w-7 h-7" width="32" height="32"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" id="icon-phone"><path fillRule="evenodd" clipRule="evenodd" d="M12.0035 8.13854C11.8329 7.56996 11.6624 7.11509 11.0938 7.05824L10.0135 7.00138C8.87632 6.94452 7 8.65026 7 11.4932C7.05686 16.4398 14.4484 24.5137 19.3382 24.9686C22.238 25.2529 24.0575 23.5471 24.1143 22.3531V21.3296C24.1712 20.7611 23.7163 20.5336 23.1477 20.3062C22.0674 19.9082 20.9871 19.3965 19.9068 18.9985C19.4519 18.8279 19.0539 19.1122 18.7696 19.2827C18.3716 19.6239 18.0873 19.8513 17.7462 20.2493C17.4619 20.4768 17.1776 20.5905 16.8933 20.3062C14.4484 19.0553 12.4584 16.8947 11.4349 14.3929C11.2075 14.0518 11.3212 13.7675 11.6055 13.5401C12.0035 13.1989 12.2878 12.9146 12.629 12.5735C12.8564 12.346 13.1407 11.948 13.027 11.4932C12.6858 10.4129 12.3447 9.21885 12.0035 8.13854Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg></svg>
                        {t("sale.Phone")}
                      </div>
                      <div className="font-light">{propsPersonal.phone}</div>
                    </div>

                    <div className="space-y-2">
                      <div className="flex items-center fw-500">
                        <svg className="mr-2 w-7 h-7" width="32" height="32"><svg viewBox="0 0 32 32" fill="none" id="icon-calendar"><path fillRule="evenodd" clipRule="evenodd" d="M20.8857 4.5C21.3586 4.5 21.7689 4.80009 21.8956 5.2411L21.9229 5.36475L21.9321 5.49239L21.9312 6.8188L23.0714 6.81957C24.5744 6.81957 25.8429 7.82412 26.1196 9.18097L26.15 9.35989L26.1688 9.54249L26.175 9.725V23.5946C26.175 25.0713 24.9974 26.2944 23.4597 26.4769L23.2657 26.4943L23.0714 26.5H8.92857C7.36022 26.5 6.0472 25.4062 5.84996 23.9597L5.83118 23.7771L5.825 23.5946V9.725C5.825 8.24823 7.00255 7.02513 8.54029 6.84262L8.73432 6.82528L8.92857 6.81957L10.0677 6.8188L10.0679 5.49239C10.0679 5.01863 10.4152 4.62793 10.8757 4.52597L10.993 4.50661L11.1143 4.5C11.5871 4.5 11.9974 4.80009 12.1241 5.2411L12.1515 5.36475L12.1607 5.49239L12.1599 6.8188H15.0177L15.0179 5.4625C15.0179 5.01122 15.3339 4.63452 15.7587 4.52929L15.8771 4.50747L16 4.5C16.4353 4.5 16.8129 4.77982 16.941 5.19669L16.9696 5.31368L16.9821 5.46266L16.9801 6.8188H19.839L19.8393 5.49239C19.8393 5.01863 20.1866 4.62793 20.6471 4.52597L20.7645 4.50661L20.8857 4.5ZM24.0817 11.5152H7.9172L7.91785 23.504C7.91785 23.977 8.24477 24.3807 8.68134 24.4867L8.80296 24.508L8.92857 24.5152H23.0714C23.5467 24.5152 23.9489 24.1857 24.0539 23.7506L24.075 23.6294L24.0821 23.504L24.0817 11.5152Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path><rect x="9.812" y="14.0802" width="3" height="3" rx="1.5" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></rect><rect x="9.812" y="18.8807" width="3" height="3" rx="1.5" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></rect><rect x="19.188" y="14.0802" width="3" height="3" rx="1.5" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></rect><rect x="14.5" y="14.0802" width="3" height="3" rx="1.5" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></rect><rect x="14.5" y="18.8807" width="3" height="3" rx="1.5" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></rect></svg></svg>
                        {t("Rent.Date of birth")}
                      </div>
                      <div className="font-light"> {moment(propsPersonal.dob).format("DD-MM-YYYY")}</div>
                    </div>

                    <div className="space-y-2">
                      <div className="flex items-center fw-500">
                        <svg className="mr-2 w-7 h-7" width="32" height="32"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" id="icon-location"><path fillRule="evenodd" clipRule="evenodd" d="M16 5C20.6947 5 24.5 8.88394 24.5 13.6749C24.5 19.8381 17.0614 25.7247 16.1016 26.4586L16.026 26.5159C16.0088 26.5288 16 26.5353 16 26.5353C16 26.5353 15.9912 26.5288 15.974 26.5159L15.8984 26.4586C14.9386 25.7247 7.5 19.8381 7.5 13.6749C7.5 8.88394 11.3053 5 16 5ZM16 8.60808C13.392 8.60808 11.2778 10.7223 11.2778 13.3303C11.2778 15.9383 13.392 18.0525 16 18.0525C18.608 18.0525 20.7222 15.9383 20.7222 13.3303C20.7222 10.7223 18.608 8.60808 16 8.60808Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg></svg>
                        {t("Rent.Street")}
                      </div>
                      <div className="font-light">{propsPersonal.street}</div>
                    </div>

                    <div className="space-y-2">
                      <div className="flex items-center fw-500">
                        <svg className="mr-2 w-7 h-7" width="32" height="32"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" id="icon-location"><path fillRule="evenodd" clipRule="evenodd" d="M16 5C20.6947 5 24.5 8.88394 24.5 13.6749C24.5 19.8381 17.0614 25.7247 16.1016 26.4586L16.026 26.5159C16.0088 26.5288 16 26.5353 16 26.5353C16 26.5353 15.9912 26.5288 15.974 26.5159L15.8984 26.4586C14.9386 25.7247 7.5 19.8381 7.5 13.6749C7.5 8.88394 11.3053 5 16 5ZM16 8.60808C13.392 8.60808 11.2778 10.7223 11.2778 13.3303C11.2778 15.9383 13.392 18.0525 16 18.0525C18.608 18.0525 20.7222 15.9383 20.7222 13.3303C20.7222 10.7223 18.608 8.60808 16 8.60808Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg></svg>
                        {t("Rent.Address addition")}
                      </div>
                      <div className="font-light">{propsPersonal.address}</div>
                    </div>

                    <div className="space-y-2">
                      <div className="flex items-center fw-500">
                        <svg className="mr-2 w-7 h-7" width="32" height="32"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" id="icon-location"><path fillRule="evenodd" clipRule="evenodd" d="M16 5C20.6947 5 24.5 8.88394 24.5 13.6749C24.5 19.8381 17.0614 25.7247 16.1016 26.4586L16.026 26.5159C16.0088 26.5288 16 26.5353 16 26.5353C16 26.5353 15.9912 26.5288 15.974 26.5159L15.8984 26.4586C14.9386 25.7247 7.5 19.8381 7.5 13.6749C7.5 8.88394 11.3053 5 16 5ZM16 8.60808C13.392 8.60808 11.2778 10.7223 11.2778 13.3303C11.2778 15.9383 13.392 18.0525 16 18.0525C18.608 18.0525 20.7222 15.9383 20.7222 13.3303C20.7222 10.7223 18.608 8.60808 16 8.60808Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg></svg>
                        {t("Rent.Zip")} & {t("Rent.City")}
                      </div>
                      <div className="font-light">{propsPersonal.zip} {propsPersonal.city}</div>
                    </div>

                    <div className="space-y-2">
                      <div className="flex items-center fw-500">
                        <svg className="mr-2 w-7 h-7" width="32" height="32"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" id="icon-location"><path fillRule="evenodd" clipRule="evenodd" d="M16 5C20.6947 5 24.5 8.88394 24.5 13.6749C24.5 19.8381 17.0614 25.7247 16.1016 26.4586L16.026 26.5159C16.0088 26.5288 16 26.5353 16 26.5353C16 26.5353 15.9912 26.5288 15.974 26.5159L15.8984 26.4586C14.9386 25.7247 7.5 19.8381 7.5 13.6749C7.5 8.88394 11.3053 5 16 5ZM16 8.60808C13.392 8.60808 11.2778 10.7223 11.2778 13.3303C11.2778 15.9383 13.392 18.0525 16 18.0525C18.608 18.0525 20.7222 15.9383 20.7222 13.3303C20.7222 10.7223 18.608 8.60808 16 8.60808Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg></svg>
                        {t("Rent.Country")}
                      </div>
                      <div className="font-light">{propsPersonal.country}</div>
                    </div>

                  </div>
                </details>
              </div>

            </div>

            <div className="xl:w-1/2">
              <div className="mt-4 p-4 bg-white xl:mt-0 xl:p-10 xl:bg-transparent md:mx-0 mx-6 md:rounded-none rounded">
                <form className="mx-auto md:py-10 py-3 max-w-xl space-y-6" onSubmit={onSubmitForm}>
                  {propsDetail.type == "Rent" ?
                    <>
                      <div className="grid grid-cols-2 items-center">
                        <div className="md:py-4 py-0 text-xl font-normal medium-text">{t("Rent.Total")}</div>
                        <div className="justify-self-end text-xl font-normal medium-text price-font">
                          <NumericFormat
                            // value={Math.round(propsDetail.totalPackages -propsDetail.discountcount)}
                            // value={Math.round(propsDetail.totalPackages)}
                            value={Math.max(0, (parseInt(propsDetail.totalPackages) + parseInt(propsDetail.pickup_charge || 0) + parseInt(propsDetail.return_charge || 0)) - parseInt(discountAmount))}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            displayType={'text'}

                          />
                          €</div>
                      </div>
                    </>
                    :
                    <>
                      <div className="grid grid-cols-2 items-center">
                        <div className="md:py-4 py-0 text-xl font-normal medium-text">{t("subscription.first month")}:</div>
                        <div className="justify-self-end text-xl font-normal small-text price-font">
                          {propsDetail.type == "Subscription" ?
                            <>
                              <NumericFormat
                                className="ms-1"
                                value={monthlyBreakdown?.[0]?.price ?? 0}
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                displayType={'text'}
                              /> €
                            </>
                            :
                            <>
                              <NumericFormat
                                className="ms-1"
                                value={Math.round(propsDetail.totalPackages + (propsDetail.pickup_charge ?? 0) + (propsDetail.return_charge ?? 0) / parseInt(differenceMonth))}
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                displayType={'text'}
                              />
                              €
                            </>
                          }
                        </div>
                      </div>
                    </>
                  }

                  <div className="font-light">{t("Rent.You will be redirected to the relevant payment provider upon booking")}.</div>

                  <div className="payment-button relative">
                    <input className="payment-radio-input" id="sofrt" type="checkbox" checked={is_paypal} onClick={handleAmount} />
                    <label className="mt-3 md:mb-3 mb-3 transition-all flex items-center px-4 h-16 border border-secondary border-opacity-disabled hover:border-transparent hover:shadow bg-white rounded cursor-pointer space-x-4" htmlFor="">
                      <div className="w-12 h-8 bg-white rounded-lg shrink-0 mb-3">
                        {/* <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.87 28.87" id="stripe"><g data-name="Layer 2"><g data-name="Layer 1"><rect width="28.87" height="28.87" fill="#6772e5" rx="6.48" ry="6.48"></rect><path fill="#fff" fill-rule="evenodd" d="M13.3 11.2c0-.69.57-1 1.49-1a9.84 9.84 0 0 1 4.37 1.13V7.24a11.6 11.6 0 0 0-4.36-.8c-3.56 0-5.94 1.86-5.94 5 0 4.86 6.68 4.07 6.68 6.17 0 .81-.71 1.07-1.68 1.07A11.06 11.06 0 0 1 9 17.25v4.19a12.19 12.19 0 0 0 4.8 1c3.65 0 6.17-1.8 6.17-5 .03-5.21-6.67-4.27-6.67-6.24z"></path></g></g></svg> */}
                        <img src="../Images/card-logo-payment.png" alt="payment-logo" />
                      </div>
                      <div className="flex-grow overflow-hidden">
                        <div className="overflow-hidden text-ellipsis text-lg sm:text-xl" >
                          {t("Rent.Card Payment")}
                        </div>
                      </div>
                      <div className="checked-hidden justify-self-end w-7 h-7 border border-secondary border-opacity-disabled rounded-full shrink-0"></div>
                      <svg className="checked-show hidden w-7 h-7 cssvar-secondary-to-primary" width="32" height="32"><svg viewBox="0 0 32 32" fill="none" id="icon-check-circle"><path fillRule="evenodd" clipRule="evenodd" d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10.7533 16.2181C11.0708 15.7706 11.6483 15.7117 12.0431 16.0865L14.2653 18.1963L19.6446 11.4402C19.9837 11.0144 20.5638 10.9928 20.9402 11.3921C21.3167 11.7914 21.347 12.4603 21.0079 12.8862L15.0481 20.3715C14.7223 20.7806 14.1708 20.8189 13.7915 20.4588L10.8933 17.7072C10.4984 17.3323 10.4358 16.6656 10.7533 16.2181Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg></svg>
                    </label>
                  </div>

                  <div className="payment-button relative">
                    <input className="payment-radio-input" id="sofrt" type="checkbox"
                      onChange={() => {
                        setIs_code(is_Cod ? false : true)
                        setIs_paypal(is_paypal ? false : true)
                        setShow(false)
                      }}
                      checked={is_Cod}
                    />
                    <label className="transition-all flex items-center px-4 h-16 border border-secondary border-opacity-disabled hover:border-transparent hover:shadow bg-white rounded cursor-pointer space-x-4" htmlFor="">
                      <div className="w-12 h-8 bg-white rounded-lg shrink-0">
                        <svg fill="#000000" width="32" height="32" version="1.1" id="Capa_1" viewBox="0 0 425.521 425.521"><g><path d="M317.233,94.552l4.794-9.228c0.273-0.06,0.549-0.106,0.818-0.191c2.402-0.76,4.404-2.442,5.565-4.678l16.597-31.944
                          c2.419-4.656,0.606-10.391-4.05-12.81l-31.86-16.553c-2.235-1.162-4.842-1.387-7.244-0.628c-2.402,0.76-4.404,2.442-5.565,4.678
                          l-16.597,31.944c-1.353,2.604-1.38,5.544-0.329,8.054l-4.744,9.131c-10.808-3.918-22.088-6.841-33.732-8.655v-8.673h8.623
                          c5.247,0,9.5-4.253,9.5-9.5V9.5c0-5.247-4.253-9.5-9.5-9.5h-73.497c-5.247,0-9.5,4.253-9.5,9.5v35.999c0,5.247,4.253,9.5,9.5,9.5
                          h8.624v8.673C97.581,77.233,30.749,152.711,30.749,243.509c0,100.362,81.65,182.012,182.012,182.012s182.012-81.65,182.012-182.012
                          C394.773,181.993,364.091,127.514,317.233,94.552z M308.767,40.387l15.001,7.793l-7.837,15.084l-15.001-7.793L308.767,40.387z
                          M295.206,73.909l8.929,4.639l-3.048,5.867c-2.926-1.631-5.897-3.188-8.919-4.66L295.206,73.909z M185.512,19h54.497v16.999
                          h-54.497V19z M203.636,54.999h18.25v6.727c-3.023-0.15-6.065-0.229-9.125-0.229c-3.06,0-6.101,0.079-9.125,0.229V54.999z
                          M212.76,406.521c-89.885,0-163.012-73.127-163.012-163.012S122.876,80.497,212.76,80.497c89.885,0,163.012,73.127,163.012,163.012
                          S302.646,406.521,212.76,406.521z"></path><path d="M212.76,98.783c-79.802,0-144.726,64.924-144.726,144.727s64.924,144.727,144.726,144.727
                          c79.803,0,144.727-64.924,144.727-144.727S292.564,98.783,212.76,98.783z M212.76,369.236
                          c-69.326,0-125.726-56.401-125.726-125.727s56.4-125.727,125.726-125.727s125.727,56.401,125.727,125.727
                          S282.086,369.236,212.76,369.236z"></path><path d="M235.385,155.2v-16.706c0-5.247-4.253-9.5-9.5-9.5s-9.5,4.253-9.5,9.5v14.922h-7.249v-14.922c0-5.247-4.253-9.5-9.5-9.5
                          s-9.5,4.253-9.5,9.5V155.2c-15.731,4.954-27.172,19.677-27.172,37.023v21.98c0,17.346,11.441,32.068,27.172,37.023v59.565
                          c-4.942-3.605-8.172-9.423-8.172-15.994c0-5.247-4.253-9.5-9.5-9.5s-9.5,4.253-9.5,9.5c0,17.346,11.441,32.068,27.172,37.023
                          v16.706c0,5.247,4.253,9.5,9.5,9.5s9.5-4.253,9.5-9.5v-14.922h7.249v14.922c0,5.247,4.253,9.5,9.5,9.5s9.5-4.253,9.5-9.5v-16.706
                          c15.732-4.954,27.173-19.677,27.173-37.023v-21.98c0-17.346-11.441-32.069-27.173-37.023v-59.565
                          c4.942,3.605,8.173,9.423,8.173,15.995v12.211c0,5.247,4.253,9.5,9.5,9.5s9.5-4.253,9.5-9.5v-12.211
                          C262.558,174.876,251.117,160.154,235.385,155.2z M216.385,172.416v61.593h-7.249v-61.593H216.385z M181.964,214.203v-21.98
                          c0-6.572,3.23-12.389,8.172-15.994v53.969C185.194,226.592,181.964,220.774,181.964,214.203z M209.136,314.603v-61.593h7.249
                          v61.593H209.136z M243.558,272.816v21.98c0,6.572-3.23,12.39-8.173,15.995v-53.97C240.327,260.426,243.558,266.244,243.558,272.816
                            z"></path></g></svg>
                      </div>
                      <div className="flex-grow overflow-hidden">
                        <div className="overflow-hidden text-ellipsis text-lg sm:text-xl cash-text" >
                          {t("Rent.Cash")}
                        </div>
                      </div>
                      <div className="checked-hidden justify-self-end w-7 h-7 border border-secondary border-opacity-disabled rounded-full shrink-0"></div>
                      <svg className="checked-show hidden w-7 h-7 cssvar-secondary-to-primary" width="32" height="32"><svg viewBox="0 0 32 32" fill="none" id="icon-check-circle"><path fillRule="evenodd" clipRule="evenodd" d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10.7533 16.2181C11.0708 15.7706 11.6483 15.7117 12.0431 16.0865L14.2653 18.1963L19.6446 11.4402C19.9837 11.0144 20.5638 10.9928 20.9402 11.3921C21.3167 11.7914 21.347 12.4603 21.0079 12.8862L15.0481 20.3715C14.7223 20.7806 14.1708 20.8189 13.7915 20.4588L10.8933 17.7072C10.4984 17.3323 10.4358 16.6656 10.7533 16.2181Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg></svg>
                    </label>
                  </div>

                  <div className="book-now-text font-light">{t("Rent.By booking your Camper, you agree to the terms and conditions of Born To Camp. Our privacy policy applies")}.</div>

                  {error ?
                    <p style={{ color: "red" }} className="mb-2 flex w-full animate-wiggle items-center justify-between rounded bg-warning px-4 py-2 text-lg text-white">
                      {error}
                    </p>
                    :
                    ''
                  }

                  <button
                    type="submit"
                    disabled={isSubmitPayment}
                    className="grid-cols1 inline-grid grid-rows-1 text-white bg-secondary hover:bg-primary mt-4 pl-5 pr-2 w-full h-12 rounded"
                  >
                    <span className="relative flex col-start-1 row-start-1 items-center justify-between w-full h-full transition-opacity duration-300">
                      <span className="transform transition-transform duration-300 translate-x-0">
                        <span className="text-18">{t("Rent.Finish Payment")}</span>
                      </span>
                      <svg
                        className="w-7 h-7 cssvar-secondary-to-white pointer-events-none"
                        width="32"
                        height="32"
                      >
                        <svg
                          viewBox="0 0 32 32"
                          fill="none"
                          id="icon-chevron-right"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M22.1256 15.9999L14.479 8.35332C14.009 7.88273 13.2445 7.88213 12.7739 8.35211L12.3532 8.77342C11.8809 9.24581 11.8833 10.0073 12.3544 10.4785L17.8759 15.9999L12.3544 21.5219C11.8833 21.9925 11.8809 22.7546 12.3532 23.2264L12.7739 23.6477C13.2445 24.1182 14.009 24.117 14.479 23.6465L22.1256 15.9999Z"
                            fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                          ></path>
                        </svg>
                      </svg>
                    </span>
                  </button>
                </form>

                <div className="absolute left-0 top-0 hidden w-full h-20 pointer-events-none md:block">
                  <div className="relative mx-auto max-w-7xl h-full">
                    <button onClick={() => navigate(-1)}
                      className="absolute -bottom-10 left-0 flex items-center px-4 pointer-events-auto"
                    >
                      <svg className="w-6 h-6" width="32" height="32"><svg viewBox="0 0 32 32" fill="none" id="icon-chevron-left"><path fillRule="evenodd" clipRule="evenodd" d="M9.87444 15.9999L17.521 8.35332C17.991 7.88273 18.7555 7.88213 19.2261 8.35211L19.6468 8.77342C20.1191 9.24581 20.1167 10.0073 19.6456 10.4785L14.1241 15.9999L19.6456 21.5219C20.1167 21.9925 20.1191 22.7546 19.6468 23.2264L19.2261 23.6477C18.7555 24.1182 17.991 24.117 17.521 23.6465L9.87444 15.9999Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg></svg>
                      <div className="fw-500">{t("Rent.Back")}</div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};
export default Payment;
